import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, message } from 'antd';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { CourtRecordsApplication } from '../CaseDetails/CaseDetails';



const CourtRecordsApplications = () => {
  const [data, setData] = useState<CourtRecordsApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<CourtRecordsApplication | null>(null);
  const navigate = useNavigate();

  const authToken = sessionStorage.getItem('token');

  useEffect(() => {
    const fetchCourtRecordsApplications = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://backend-kyw8.onrender.com/court-records/judge', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const jsonData = await response.json();
        const courtRecordsApplications = jsonData.applications.filter(
          (app: CourtRecordsApplication) => app.applicationType === 'COURT_RECORD'
        );
        setData(courtRecordsApplications);
        console.log(courtRecordsApplications);
      } catch (error) {
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourtRecordsApplications();
  }, [authToken]);

  const handlereject = async (applicationId: string | undefined) => {
    const approved = false;
    try {
      const response = await fetch(`"https://backend-kyw8.onrender.com/court-records"`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            applicationId,
            approved
        })
      });
      const data = await response.json();
      console.log(data);
      if (!response.ok) {
        throw new Error(data.error ?? 'An error occurred');
      }
      message.success('Application rejected successfully');
      handleModalClose();
      return data;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  
  const showModal = (record: CourtRecordsApplication) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  const showConfirmationModal = (action: 'approve' | 'reject') => {
    Modal.confirm({
      title: `Are you sure you want to ${action} this application?`,
      content: `This action will ${action} the Court Record application.`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        // Handle the approve or reject action here
        message.success(`Application ${action}ed successfully`);
  
        // Navigate only on approve
        if (action === 'approve') {
          navigate(`/dashboard/upload-ruling/${selectedRecord?.caseId}/${selectedRecord?.applicationType}/${selectedRecord?.id}`);
        }
        if (action === 'reject') {
          handlereject(selectedRecord?.id);
        }
      },
    });
  };

  const columns = [
    {
      title: 'Suit NO',
      dataIndex: ['case', 'suitNumber'], // Updated to access nested case.suitNumber
      key: 'suitNumber',
    },
    {
      title: 'Digital Seal',
      dataIndex: 'digitalSeal',
      key: 'digitalSeal',
      render: (text: string) => (
        <a href={text} target="_blank" rel="noopener noreferrer" className='hover:text-[#9B111E]'>
          View Seal
        </a>
      ),
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      key: 'signature',
      render: (text: string) => (
        <a href={text} target="_blank" rel="noopener noreferrer" className='hover:text-[#9B111E]'>
          View Signature
        </a>
      ),
    },
    {
      title: 'Approval Document',
      dataIndex: 'approvalDocument',
      key: 'approvalDocument',
      render: (documents: string[]) =>
        documents.length > 0 ? (
          documents.map((doc, index) => (
            <div key={index}>
              <a href={doc} target="_blank" rel="noopener noreferrer">
                View Document {index + 1}
              </a>
            </div>
          ))
        ) : (
          <span>Not Available</span>
        ),
    },
    {
      title: 'Go to case',
      key: 'actions',
      render: (record: CourtRecordsApplication) => (
        <Link to={`/dashboard/case-details/${record.caseId}`}>
          <Button type="primary" className="bg-brown hover:bg-lightBrown">View Case</Button>
        </Link>
      ),
    },
    {
      title: 'Approve/Reject',
      key: 'modalAction',
      render: (record: CourtRecordsApplication) => {
        if (record.approved) {
          return <span><strong>Approved</strong></span>;
        } 
        // else if (!record.approved) {
        //   return <span><strong>Rejected</strong></span>;
        // }
        else {
          return (
            <Button
              type="primary"
              className="bg-brown hover:bg-lightBrown"
              onClick={() => showModal(record)}
            >
              Approve/Reject
            </Button>
          );
        }
      },
    },
  ];
  const TablePaginationConfig = {
    pageSize: 10, 
    showSizeChanger: false,
    showTotal: (total) => `Total ${total} items`, 
  };

  return (
    <div>
      <p className='form-header'>Court Records Applications</p>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="caseId"
        loading={loading}
        pagination={TablePaginationConfig}
        className="custom-table"
      />
      {error && <p>Error: {error.message}</p>}

      {/* Modal */}
      <Modal
        title="Court Records Application Details"
        open={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
          <Button key="approve" type="primary" onClick={() => showConfirmationModal('approve')}>
            Approve
          </Button>,
          <Button key="reject" type="primary" danger onClick={() => showConfirmationModal('reject')}>
            Reject
          </Button>,
        ]}
      >
        {selectedRecord ? (
          <div>
            <p><strong>Suit NO:</strong> {selectedRecord.case.suitNumber}</p>
            {/* Add more details as needed */}
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </div>
  );
};

export default CourtRecordsApplications;
